<template>
  <div
    class="flex w-full lg:justify-end md:justify-start justify-center  items-center mt-10"
    :class="
      direction === 'col'
        ? 'flex-col'
        : 'md:flex-row flex-col md:items-baseline'
    "
  >
    <picture class="blablacar-img" :class="direction === 'col' ? 'mb-6' : ''">
      <source
        srcset="@/assets/images/blablacar-logotipo.webp"
        type="image/webp"
      />
      <img
        :src="require('@/assets/images/blablacar-logo.png')"
        :alt="$t('magazine.widgetAlt.logoIcon', { socialMedia: 'Blablacar' })"
        loading="lazy"
      />
    </picture>
    <div
      :class="
        direction === 'col'
          ? 'ml-0 flex flex-col items-center'
          : 'searchTransport-btn'
      "
    >
      <wegow-button
        button-id="blablacar-btn"
        class="md:inline-block hidden mb-2"
        color="white"
        background="transparent"
        border="topaz"
        custom-padding="6px 23px"
        :text="$t('profiles.buttons.findYourTrip')"
        @click="redirect(), sendGA('blablacarFindTrip')"
      />
      <wegow-button
        button-id="blablacar-btn"
        class="md:hidden inline-block mb-2"
        color="topaz-light"
        background="opacity"
        custom-padding="6px 23px"
        :text="$t('profiles.buttons.findYourTrip')"
        @click="redirect(), sendGA('blablacarFindTrip')"
      />
      <a
        target="_blank"
        class="btn small btn-secondary btn-transport publish-btn"
        href="https://www.blablacar.es/offer-seats/?comuto_cmkt=ES_WEGOW_ACQ_DRVR_BANNER_INTEGRATED"
        @click="sendGA('blablacarPublishTrip')"
      >
        <span>{{ $t("profiles.buttons.publishYourTrip") }}</span>
      </a>
    </div>
  </div>
</template>

<script setup>
import { event } from "vue-gtag";
import WegowButton from "@/components/general/forms/WegowButton";

const props = defineProps({
  direction: {
    type: String,
    default: ""
  }
});

const sendGA = value => {
  event(value, {
    event_category: "transport"
  });
};
const redirect = () => {
  window.open(
    "https://www.blablacar.es/search-car-sharing/?comuto_cmkt=ES_WEGOW_ACQ_PSGR_BANNER_INTEGRATED",
    "_blank"
  );
};
</script>

<style lang="scss" scoped>
.btn-secondary {
  background: transparent;
  border-color: $topazclaro;
  padding: 2px 25px !important;
  &:not(:disabled):hover {
    background-color: transparent;
    border-color: $topazclaro;
  }
}
.searchTransport-btn {
  display: flex;
  flex-direction: column;
  @media screen and (min-width: $screen-md) {
    margin-left: 84px;
  }
  @media screen and (min-width: $screen-lg) {
    margin-left: 43px;
  }
}
.blablacar-img img {
  height: 29px;
  width: 148px;
  margin-bottom: 23px;
  @media screen and (min-width: $screen-md) {
    margin-bottom: 0;
  }
}
.publish-btn {
  font-size: 1rem;
  color: $topaz;
  text-align: center;
}
</style>
